module.exports = __webpack_public_path__ + "static/media/arrow.f3e2a23e.svg";